export type SettingsTab =
  | 'details'
  | 'services'
  | 'scenarios'
  | 'prerequisites'
  | 'health-checks'

const BASE_LARGE_SCALE_URL = '/large-scale-tests'

export const LARGE_SCALE_URLS = {
  base: () => BASE_LARGE_SCALE_URL,
  byIdentifier: (largeScaleTestId: string) =>
    `${BASE_LARGE_SCALE_URL}/${largeScaleTestId}`,
  new: () => `${BASE_LARGE_SCALE_URL}/new`,
  settings: (largeScaleTestId: string, settingsTab?: SettingsTab) => {
    const tab = settingsTab ? `/${settingsTab}` : ''
    return `${BASE_LARGE_SCALE_URL}/${largeScaleTestId}/settings${tab}`
  },
  reportByIdentifier: (largeScaleTestId: string) =>
    `${BASE_LARGE_SCALE_URL}/${largeScaleTestId}/report`
}
